import { replaceDomainForCacheKey } from '@americanexpress/fetchye-amex';
import { MODULE_NAME } from '../constants/modules';

export const generateReporting = (component) => (
  { key, options, error }) => ({
  moduleID: MODULE_NAME,
  component,
  fetch: {
    url: key,
    status: error?.status,
    correlationId: options.headers?.['Correlation-ID'] || '',
  },
});

export const fetchyeOpts = {
  mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
};
